import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import GoogleMapReact from 'google-map-react';

import { mapOptions } from 'src/const';

import {
  DISTRICT_INDEX,
  COORDINATE_INDEX,
  COUNTRY_NAME_INDEX,
  COUNTRY_CODE_INDEX,
  SUBSCRIPTION_NUMBERS_INDEX,
  USER_EMAIL_INDEX,
  activeMarketsArrayType,
} from './ActiveMarkersConst';

const Marker = (props: any) => {
  const { district, countryName, countryCode, subscriptionCount, email } = props;

  return (
    <Tooltip
      title={
        <>
          <Typography variant="h5">{district}</Typography>
          <br />
          <Typography variant="body1">
            {countryName == 0 ? '' : countryName}, {countryCode == 0 ? '' : countryCode}
          </Typography>
          <Typography variant="body2">Subscribed by {subscriptionCount} people</Typography>
          <Typography variant="body2">Email: {email}</Typography>
          <br />
        </>
      }
      arrow
    >
      <div
        style={{
          width: '10px',
          height: '10px',
          background: 'red',
          borderRadius: '50%',
        }}
      />
    </Tooltip>
  );
};

const GoogleMapComponent = ({ markets }: { markets: activeMarketsArrayType[] }) => {
  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk',
        libraries: ['drawing', 'places', 'visualization'],
        id: 'dashboard',
      }}
      center={{ lat: 33.7753832, lng: -38.2961321 }} //center of north atlantic
      options={mapOptions}
      zoom={1}
      resetBoundsOnResize
      yesIWantToUseGoogleMapApiInternals
    >
      {markets.map(market => {
        const coordinates = market[COORDINATE_INDEX].split(', ').map(Number);
        if (isNaN(coordinates[0])) return null;
        if (isNaN(coordinates[1])) return null;

        return (
          <Marker
            lat={coordinates[1]}
            lng={coordinates[0]}
            district={market[DISTRICT_INDEX]}
            countryName={market[COUNTRY_NAME_INDEX]}
            countryCode={market[COUNTRY_CODE_INDEX]}
            subscriptionCount={market[SUBSCRIPTION_NUMBERS_INDEX]}
            email={market[USER_EMAIL_INDEX]}
          />
        );
      })}
    </GoogleMapReact>
  );
};

export default GoogleMapComponent;
